import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import { Sparkles, ArrowRight } from 'lucide-react';

const UpgradeBanner = () => {
  const navigate = useNavigate();
  const { user } = UserAuth();
  const [isProUser, setIsProUser] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user) {
          const idTokenResult = await user.getIdTokenResult();
          setIsProUser(idTokenResult.claims.plan !== undefined && idTokenResult.claims.plan !== 'free');
        }
      } catch (error) {
        console.error("Error fetching subscription status:", error);
        setIsProUser(false);
      }
    };

    fetchData();
  }, [user]);

  const account = () => {
    navigate('/account/new');
  };

  if (isProUser) return null;

  return (
    <div 
      onClick={account}
      style={{
        position: 'absolute',
        background: 'transparent',
        border: '2px solid var(--Yellow)',
        padding: '0px',
        borderRadius: '12px',
        marginTop: '3em',
        maxWidth: '300px',
        cursor: 'pointer',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(57, 57, 57, 0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={{
        background: 'var(--theme-bg-color)',
        borderRadius: '10px',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <Sparkles 
          size={18} 
          style={{
            color: 'var(--secondary)',
            animation: 'sparkle 1.5s ease-in-out infinite'
          }}
        />
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <span style={{
            color: 'var(--secondary)',
            fontSize: 'var(--H4)',
            fontWeight: 'var(--H4-weight)',
            fontFamily: 'var(--H4-family)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            Obten plus
            <ArrowRight size={16} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default UpgradeBanner;